import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Component } from 'react';
import { ErrorIcon } from './errorIcon';
import { Wrapper } from './lightCardWrappers';
import { getDimensionsWithDefault } from './getDimensionsWithDefault';
export var CardError = /*#__PURE__*/function (_Component) {
  function CardError() {
    _classCallCheck(this, CardError);
    return _callSuper(this, CardError, arguments);
  }
  _inherits(CardError, _Component);
  return _createClass(CardError, [{
    key: "render",
    value: function render() {
      var dimensions = getDimensionsWithDefault(this.props.dimensions);
      return /*#__PURE__*/React.createElement(Wrapper, {
        dimensions: dimensions
      }, this.icon);
    }
  }, {
    key: "icon",
    get: function get() {
      var size = this.props.size;
      return /*#__PURE__*/React.createElement(ErrorIcon, {
        size: size
      });
    }
  }]);
}(Component);
_defineProperty(CardError, "defaultProps", {
  size: 'medium'
});